import StyledAutocomplete  from "./StyledAutocomplete";  

export default StyledAutocomplete;
